import { useEffect, useRef } from "react";
import ReportViewer from "../../../../../components/ReportViewer";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import { useGetReferralById } from "../../../../../queries/collaboration/referral/use-get-referral-by-uuid";
import { getXtenantId } from "../../../../../utils/utils";
import ReferralTemplate from "./ReferralTemplate";

const PrintReferral = ({
  disclosureHost,
}: {
  disclosureHost: DisclosureHost;
}) => {
  const pdfRef = useRef<{ generatePdf: () => void }>(null);

  const { data, isLoading } = useGetReferralById({
    referralId: disclosureHost?.data,
    xTENANTID: getXtenantId() as string,
  });

  const referralData = data?.data;

  useEffect(() => {
    if (referralData) {
      setTimeout(() => {
        pdfRef.current?.generatePdf();
      }, 1000);
    }
  }, [referralData]);

  return disclosureHost?.opened ? (
    <ReportViewer
      pdfRef={pdfRef}
      loading={isLoading}
      onClose={() => disclosureHost?.close()}
      title="Referral"
    >
      {referralData && <ReferralTemplate data={referralData} />}
    </ReportViewer>
  ) : null;
};

export default PrintReferral;
